export default __webpack_public_path__ + "images/models/2f5da8848914ceda8892873b4a760316.usdz";